"use client";

import Image from "next/image";
import React from "react";
import { useApp } from "@/forApp/states/appState/appState";
import Button from "@/shared/Buttons/Button";
import styles from "./styles.module.css";

const ServicePartnerBanner = () => {
	const { addModal } = useApp();
	return (
		<section className={styles.bannerWrapper}>
			<div>
				<h3>Услуги наших партнеров</h3>
				<p>
					Наши партнеры - это эксперты, которые решают любые вопросы по
					недвижимости. Они помогут провести сделку любой сложности, особое
					внимание уделяя безопасности её проведения.
				</p>
				<p>Если вам нужна помощь в выборе услуг - мы поможем с выбором!</p>
				<Button
					text={"Получить консультацию"}
					color={"dark"}
					onClick={() => {
						addModal({
							name: "ConsultationModal",
							title: "Получить консультацию",
						});
					}}
				/>
			</div>
			<Image
				alt={"Услуги партнеров"}
				width={351}
				height={351}
				src={"/imgs/frends.webp"}
				className={styles.img}
			/>
		</section>
	);
};

export default ServicePartnerBanner;
